import React, { PropTypes, Component } from 'react';
import classes from './branchBanner.scss';

class BranchBanner extends Component {
  state = {
    active: false,
  }

  ctaClicked = () => {
    this.props.onClick();
  }

  onClose = () => {
    this.setState({ active: false });
    this.props.onClose();
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ active: true });
    }, 0);
  }

  render() {
    const containerStyles = {
      height: this.state.active ? '' : '0px',
    };

    const bannerStyles = {
      top: this.state.active ? '0%' : '',
    };

    if (this.props.duration && this.props.easing) {
      containerStyles.transitionDuration = this.props.duration;
      containerStyles.transitionTimingFunction = this.props.easing;
      bannerStyles.transition = `top ${this.props.duration} ${this.props.easing}`;
    }

    return(
      <div className={ classes.bannerContainer } style={ containerStyles }>
        <div className={ classes.bannerWrapper } style={ bannerStyles }>
          <div className={ classes.left }>
            <div className={ classes.close } onClick={ this.onClose }>×</div>
            <img className={ classes.appIcon } src={ this.props.iconUrl } />
            <div className={ classes.details }>
              <span className={ classes.title }>Raise</span>
              <span className={ classes.description }>Get instant savings to your favorite stores</span>
            </div>
          </div>
          <div className={ classes.right }>
            <img className={ classes.badge } src={ this.props.badgeUrl } />
          </div>
          <div className={ classes.hitbox } onClick={ this.ctaClicked }></div>
        </div>
      </div>
    );
  }
}

BranchBanner.propTypes = {
  deviceType: PropTypes.string.isRequired,
  duration: PropTypes.string,
  easing: PropTypes.string,
  iconUrl: PropTypes.string.isRequired,
  badgeUrl: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BranchBanner;



/** WEBPACK FOOTER **
 ** ./apps/storePages/branch/components/BranchBanner.js
 **/